// Stylised hint only — the wizard doesn't ask the customer directly.
// `vehicleSize` is informational; KeikkaPumpIcon derives visual layers from `isPumi`.
export function inferVehicleType({ m3, puomi }) {
    const totM3 = Number(m3) || 0;
    const boom = Number(puomi) || 0;
    if (totM3 <= 20) {
        return { isPumi: true, vehicleSize: boom > 0 ? "pumi-boom" : "pumi-noboom" };
    }
    if (totM3 <= 40) {
        return { isPumi: false, vehicleSize: boom > 0 ? "small-boom" : "small-noboom" };
    }
    return { isPumi: false, vehicleSize: boom > 0 ? "big-boom" : "big-noboom" };
}
